/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-require-imports */

import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useState} from 'react';
import {Text, View} from 'react-native';
import {connect} from 'react-redux';

import {menuListe} from '../../../data/constants/home';
import {ApiResponse} from '../../../data/types/interface/api';
import {StackParams} from '../../../data/types/navigation';
import {AccountServices} from '../../../services/applicatif/account';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {put} from '../../../services/technique/api';
import {MenuItem} from '../../components';
import {BrightenIcon} from '../../components/BrightenIcon/index.web';
import Carousel from '../../components/Carousel';
import {ChatIcon} from '../../components/Chat/ChatIcon/index.web';
import {HeaderScreen} from '../../components/Header/HeaderScreen';

type NavigationProps = StackNavigationProp<StackParams, 'Home'>;

export function HomeComponent(props: any) {
  const {navigate} = useNavigation<NavigationProps>();
  const {
    vpc_TxnResponseCode: responseCode,
    vpc_MerchTxnRef: transactionId,
    vpc_ReceiptNo: reference,
    vpc_VerToken: paiementToken,
  } = props.route && props.route.params ? props.route.params : '';
  const {
    getAnnoncesEnAvantDemarche,
    user,
    notificationNotSeenUser,
    signOutUser,
  } = props;
  const [listItem, setListItem] = useState<never[]>([]);

  user && user.initialRoute === 'PageNotFound' && navigate('PageNotFound');
  user &&
    user.initialRoute === 'ServeurIndisponible' &&
    navigate('ServerIndisponible');
  useEffect(() => {
    const updatePaiementStatus = async () => {
      try {
        await put('cb', {
          transactionId,
          paiementToken,
          reference,
          status: responseCode === '0' ? 'Succès' : 'Échoué',
        });

        window.postMessage('close', '*');
        window.opener?.postMessage('close', '*');
      } catch (error) {
        console.log(error);
      }
    };
    if (user?.data?.accessToken && transactionId) {
      updatePaiementStatus();
    }
  }, []);

  const handleLogout = () => {
    signOutUser({}, (data: any) => {
      navigate('Home');
    });
  };

  useFocusEffect(
    React.useCallback(() => {
      user?.data?.utilisateur
        ? AccountServices()
            .checkAccount(user.data.utilisateur.email, 'TestsToDelete12345')
            .then((res: ApiResponse) => {
              if (
                res.isError &&
                res.message ===
                  'Email non trouvé dans la base ou utilisateur inactif'
              ) {
                handleLogout();
              }
            })
        : console.log('no logged user');
    }, []),
  );

  useEffect(() => {
    user.data &&
      user.data.utilisateur &&
      user.data.utilisateur.id &&
      notificationNotSeenUser(
        {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (_res: ApiResponse) => {},
        `${user.data && user.data.utilisateur && user.data.utilisateur.id}`,
      );

    getAnnoncesEnAvantDemarche({}, (res: ApiResponse) => {
      if (res && res.data && res.data.items) {
        setListItem(res.data.items);
      }
    });
  }, [getAnnoncesEnAvantDemarche]);

  return (
    <View style={{flex: 1}}>
      {responseCode ? (
        <Text />
      ) : (
        <>
          <HeaderScreen title="" type="home" noBreadcrumb={true} />
          <Carousel listItem={listItem} />
          <MenuItem data={menuListe} isHome />
          <BrightenIcon>
            <ChatIcon />
          </BrightenIcon>
        </>
      )}
    </View>
  );
}

export const Home = connect(mapStateToProps, mapDispatchToProps)(HomeComponent);
